import { TemporaryAccessState } from "../enums/TemporaryAccessState";
import { emptyTemporaryAccessDetails } from "./EmptyTempAccessDetails.const";

export const initialTemporaryAccessModel = {
    details: emptyTemporaryAccessDetails,
    state: {
        descriptor: TemporaryAccessState.OK
    }
};
